@if (trainerViewModel) { 
  <div class="trainer-card">
    <div 
      class="trainer-image"
      [style.width]="avatarSize"
      [style.height]="avatarSize"
    >
      @if (trainerViewModel.image) {
        <img 
          [src]="trainerViewModel.image" 
          [alt]="trainerViewModel.fullName"
          [title]="trainerViewModel.fullName"
        />
      } @else {
        <span class="avatar-initials" [title]="trainerViewModel.fullName">
          {{ trainerViewModel.initials }}
        </span>
      }
    </div>

    <p 
      class="trainer-name"
      [style.fontSize]="fontSize"
      [style.color]="fontColor"
      [title]="trainerViewModel.fullName"
    >
      {{ trainerViewModel.name }}
    </p>
  </div>
}